module.exports = __webpack_public_path__ + "static/img/partner-ytgj.670abd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-ytgj.png
// module id = 6Hp3
// module chunks = 34